import { FC, ReactElement } from 'react'

import { SvgIconProps } from '@/components/Icon/Icon'

export const IconTarget: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg
        aria-hidden="true"
        className={`icon-component ${className}`}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <circle className="stroke" cx="12" cy="12" r="10" />
        <circle className="stroke" cx="12" cy="12" r="6" />
        <circle className="stroke" cx="12" cy="12" r="2" />
    </svg>
)
